import React from "react";
import moment from "moment";
import { change, Field, reduxForm } from "redux-form";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import styled from "styled-components";

// Actions
import {
  fetchDepartingTrips,
  fetchLocationSuggestions
} from "../../../data/trips/actions";

// Selectors
import { getLandingPageFormValues } from "../../../data/landingPageForm/selectors";

// Components
import MediaQuery from "../../../components/MediaQuery";
import { RadioButton } from "material-ui/RadioButton";
import PassengerCabinField from "../PassengerCabinField";
import AutoCompleteField from "../AutoCompleteField";
import { DatePicker, RadioButtonGroup } from "redux-form-material-ui";

// Styled Components
const FormHeader = styled.h2`
  // color: grey;
  // color: #5b5b5b;
  // color: #66615b;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 400;
  text-align: center;
  letter-spacing: 1px;
  font-size: 3em;

  ${MediaQuery.tablet`
    font-size: 2em;
    margin-top: 0;
  `};
`;

let styles = {
  inputStyle: {
    fontSize: "16px",
    // color: "white",
    // color: "grey",
    color: "#66615b",
    fontFamily: '"Montserrat", sans-serif',
    textOverflow: "ellipsis"
  },
  iconStyle: {
    // fill: "white"
    // fill: "grey"
    fill: "#66615b"
  },
  floatingLabelStyle: {
    // color: "white"
    // color: "grey"
    color: "#66615b"
  },
  underlineStyle: {
    // borderColor: "grey"
    borderColor: "#66615b"
  },
  underlineFocusStyle: {
    // borderColor: '#ffa500',
    borderColor: "#EB5E28" // btn-danger color
  },
  searchBtn: {
    margin: "0 auto",
    display: "block",
    width: "30%",
    borderRadius: "5px"
  }
};

const renderAutoCompleteField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  // <div>
  <AutoCompleteField
    error={error}
    touched={touched}
    {...input} // redux-form props e.g. onChange, onBlur, onFocus etc.
    {...custom}
  />
  // </div>
);

class LandingPageForm extends React.Component {
  componentDidMount() {
    // componentWillMount() {
    this.props.dispatch({ type: "RESET_STATE" }); // This resets redux state to defaults EXCEPT redux-form states.
    this.props.reset(); // This resets redux-form's landingPageForm to init/pristine values
    // this.props.touch('location_from')
    // this.props.touch('trip_type')

    // TODO: BUG! this.props.reset doesn't validate when you press Enter, because @@redux-form/UPDATE_SYNC_ERRORS isn't called.
    // User must type something or interact with redux-form (then @@redux-form/UPDATE_SYNC_ERRORS is called)
    // for validation to be possible.
  }

  // Submit
  handleFetchTrips = values => {
    const {
      dispatch,
      history,
      to,
      from,
      isRoundTrip, // const isRoundTrip = trip_type === "round_trip"; // Also "!!return_date"
      passengers,
      departDate,
      returnDate,
      preferredCabin
    } = this.props;
    // redux-form BUG:
    // Whenever state is reset in componentDidMount (this.props.reset), if user doesn't interact with
    // form and hits submit, for some reason redux-form allows all empty values to
    // get here.
    // This happens because upon redux-form reset, @@redux-form/UPDATE_SYNC_ERRORS isn't called.
    // User must interact with redux-form (then @@redux-form/UPDATE_SYNC_ERRORS is called)
    // for validation to be possible.

    // Validation to counter redux-form bug:
    // We perform a manual check her to ensure we have all values prior to submission
    // to server.
    if (
      !(departDate && from && to && preferredCabin && passengers.adultCount)
      // Note: we don't add (returnDate && isRoundTrip) validation
      // because when Round trip is picked in UI, bug is fixed as  @@redux-form/UPDATE_SYNC_ERRORS
      // is dispatched by redux-form; needed for it to do validations
    ) {
      // Reaches here due to redux-form bug!
      return;
    }

    if (
      from.locationIdType === "manually_entered" ||
      to.locationIdType === "manually_entered"
    ) {
      // Send us to /location-suggestions page, where we confirm the manually entered locations
      const formValues = {
        location1: from, // { "locationId": "chicag", "locationIdType": "manually_entered" }
        location2: to // { "locationId": "lagos", "locationIdType": "manually_entered" }
      };

      dispatch(fetchLocationSuggestions({ history, formValues }));
    } else {
      const formValues = {
        isRoundTrip, // true
        // departureDate: depart_date && formatDate(depart_date), // "2018-06-15",
        // returnDate: return_date && formatDate(return_date), // "2018-07-10",
        returnDate, // "2018-07-10",
        departDate, // "2018-06-15",
        location1: from, // "CHI",
        location2: to, // "LAX",
        cabinClass: preferredCabin, // economy,premium,business,first (PPN Enum Values)
        // "cabinClass": "economy",
        children: passengers.childCount, // 1
        adults: passengers.adultCount // 1
      };

      dispatch(fetchDepartingTrips({ history, formValues }));
    }
  };

  render() {
    const {
      dispatch,
      handleSubmit,
      // apiDataSource,
      // fetchAutoCompleteLocations,
      // fetchingAutoCompleteLocations,
      rawDepartDate,
      rawReturnDate,
      isRoundTrip
    } = this.props;

    return (
      <div class="landing-page">
        {/* <FormHeader> Where would you like to go? </FormHeader> */}
        <FormHeader> Book a flight, pay in installments. </FormHeader>

        <form class="container">
          <Field name="trip_type" component={RadioButtonGroup}>
            <RadioButton
              labelStyle={{ ...styles.inputStyle, marginBottom: "10px" }}
              iconStyle={styles.iconStyle}
              value="one_way"
              label="One Way"
            />
            <RadioButton
              labelStyle={styles.inputStyle}
              iconStyle={styles.iconStyle}
              value="round_trip"
              label="Round Trip"
            />
          </Field>
          <div class="landing-page__fields-container">
            <div class="landing-page__field-lg">
              <Field
                name="location_from"
                placeholderText="From"
                autoFocus
                component={renderAutoCompleteField}
              />
            </div>
            {/* <input type="text" autoFocus /> */}
            <div class="landing-page__field-lg">
              <Field
                name="location_to"
                placeholderText="To"
                component={renderAutoCompleteField}
              />
            </div>

            <div class="landing-page__field-sm">
              <Field
                component={DatePicker}
                name="depart_date"
                // container="inline"
                autoOk={true}
                // floatingLabelFixed={true}
                floatingLabelText="Depart"
                fullWidth
                minDate={new Date()}
                onChange={(nada, selectedDepartDate) => {
                  // Changing return_date val for ReduxForm. Without ReduxForm (using pure MUI date component), adding the logic
                  // to value prop of return_date (value={returnDate > departDate ? returnDate : departDate}) would suffice
                  // if (isRoundTrip) {

                  // returnDate is "YYYY-MM-DD", so we need to convert it to Date Object to use in comparison
                  // const rawReturnDate = moment(returnDate).toDate()
                  const formattedReturnDate =
                    rawReturnDate > selectedDepartDate
                      ? rawReturnDate
                      : selectedDepartDate;

                  dispatch(
                    change(
                      "landingPageForm",
                      "return_date",
                      formattedReturnDate
                    )
                  );
                }}
                inputStyle={styles.inputStyle}
                floatingLabelStyle={styles.floatingLabelStyle}
                underlineFocusStyle={styles.underlineFocusStyle}
                underlineStyle={styles.underlineStyle}
              />
            </div>

            <div class={`landing-page__field-sm ${!isRoundTrip && "hidden"}`}>
              <Field
                autoOk={true}
                component={DatePicker}
                name="return_date"
                floatingLabelText="Return"
                fullWidth
                // convert "YYYY-MM-DD" to date object || new Date()
                // minDate={moment(departDate).toDate() || new Date()}
                minDate={rawDepartDate || new Date()}
                // // minDate={moment(departDate).toDate() || new Date()}

                // // value={returnDate > departDate ? returnDate : departDate}
                // onChange={(nada, selectedReturnDate) => {
                //   // dispatch();
                //   setLandingPageFormValues({ return_date: formatDate(selectedReturnDate) })
                // }}
                inputStyle={styles.inputStyle}
                floatingLabelStyle={styles.floatingLabelStyle}
                underlineFocusStyle={styles.underlineFocusStyle}
                underlineStyle={styles.underlineStyle}
              />
            </div>

            <div class="landing-page__field-lg">
              <PassengerCabinField />
            </div>
          </div>

          <div class="row" style={{ margin: "30px 0" }}>
            <input
              style={styles.searchBtn}
              type="button"
              class="btn btn-danger btn-fill"
              value="Search"
              onClick={handleSubmit(this.handleFetchTrips)}
            />
          </div>
        </form>
      </div>
    );
  }
}

function validate(values, props) {
  const location_from = values["location_from"];
  const location_to = values["location_to"];

  // let isLocationFromEmpty = true;
  // if (location_from) {
  //     isLocationFromEmpty = isEmpty(location_from.locationId);
  // }

  const isLocationFromEmpty =
    !location_from || (location_from && isEmpty(location_from.locationId)); // Incase user types, then deletes
  const isLocationToEmpty =
    !location_to || (location_to && isEmpty(location_to.locationId)); // Incase user types, then deletes

  const isDropDownLocationEqual =
    location_from &&
    location_to &&
    location_from.locationIdType !== "manually_entered" &&
    location_to.locationIdType !== "manually_entered" &&
    (location_from.city && location_to.city) && // without this, undefined === undefined = true
    location_from.city === location_to.city;

  const isUserEnteredLocationEqual =
    location_from &&
    location_to &&
    location_from.locationIdType === "manually_entered" &&
    location_to.locationIdType === "manually_entered" &&
    location_from.locationId.toLowerCase() ===
      location_to.locationId.toLowerCase();

  var errors = {};
  var errorMessage;

  if (isUserEnteredLocationEqual || isDropDownLocationEqual) {
    errorMessage = `"From" and "To" locations cannot be the same`;
    errors["location_from"] = errorMessage;
    errors["location_to"] = errorMessage;
  }

  // If departure date is < 2 weeks, warn user that full trip would be paid.
  const today = new Date();
  const departDate = values["depart_date"];
  // const departDatePlusTwoWeeks = moment(departDate).add(2, "weeks");
  const todayPlusTwoWeeks = moment(today).add(2, "weeks");

  if (todayPlusTwoWeeks.isAfter(departDate)) {
    errors[
      "depart_date"
    ] = `Depart date cannot be less than 2 weeks from today. See "How It Works"`;
  }

  errorMessage = "Required";

  if (isEmpty(values["return_date"])) {
    errors["return_date"] = errorMessage;
  }
  if (isEmpty(values["depart_date"])) {
    errors["depart_date"] = errorMessage;
  }

  if (isLocationFromEmpty) {
    errors["location_from"] = errorMessage;
  }
  if (isLocationToEmpty) {
    errors["location_to"] = errorMessage;
  }

  function isEmpty(obj) {
    return !obj || (typeof obj === "string" && !!obj.trim() === false);
  }

  return errors;
}

function mapStateToProps(state) {
  return {
    ...getLandingPageFormValues(state),
    initialValues: {
      trip_type: "one_way"
    }
  };
}

// Decorate with redux-form
const LandingPageFormHOC = reduxForm({
  form: "landingPageForm",
  destroyOnUnmount: false, // Prevent form values from being destroyed when page is navigated away
  validate
})(LandingPageForm);

// export default LandingPageFormHOC;
export default withRouter(connect(mapStateToProps)(LandingPageFormHOC));



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/LandingPageForm/index.js